import {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../../api/Request';
import { ProgressContext } from '../../../components/Context/progressContext';
import MarketingNavigation from '../../../navigation/marketing';
import { showArticleBlock } from '../../../utils/static-pages/function';
import { PAGES_SLUG } from '../../../utils/static-pages/model';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';

export default function ProductsServices() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: PAGES_SLUG.PRODUCTS_SERVICES
                    }
                );
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({ isLoading: true });
            await fetchPage();
            updateProgress({ isLoading: false });
        }

        initPage();
    }, []);


    return (
        <>
            <Head>
                <title>Products and Services | Industry Leader | Kingdom Advisors</title>
                <meta name="description" content="Kingdom Advisors provides members a range of top-tier financial products & services to better align with values of clients seeking biblical financial counsel." />
            </Head>
            <MarketingNavigation>
                <div className='products-services'>
                    {articleBlocks && articleBlocks.map((item, index) => (
                        showArticleBlock(item, index)
                    ))}
                </div>
            </MarketingNavigation>
        </>
    )
}

ProductsServices.getLayout = page => <>{page}</>;
ProductsServices.isPublic = true;
